'use client';

import React, { useState } from 'react';
import type { OffersData } from './types';
import Heading from '../Heading/Heading';
import OfferCard from '../OfferCard/OfferCard';
import OfferDetails from '../OfferCard/OfferDetails';
import { OfferCardData } from '../OfferCard/types';
// import Link from 'next/link';
import SecondaryCtaLink from '../SecondaryCtaLink/SecondaryCtaLink';

const Offers_Component: React.FC<{ data: OffersData }> = ({ data }) => {
  const { name, leftOffer, rightOffer, link, multipleOffers } = data;
  const [selectedOffer, setSelectedOffer] = useState<OfferCardData | null>(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  return (
    <section className='w-full flex flex-col items-center gap-8 md:gap-16 @container max-md:bg-brand-offers-bg px-6 xl:px-0 mx-auto max-w-[1248px] py-16 lg:py-24'>
      {name && (
        <div className='text-center max-w-2xl w-full text-balance'>
          <Heading
            data={{
              headingType: 'H2',
              text: name,
              alignment: 'Center',
              className: 'max-md:text-white',
            }}
          />
        </div>
      )}

      {multipleOffers ? (
        <div className='w-full grid grid-cols-1 md:grid-cols-2 gap-8 @max-md:grid-cols-1'>
          {multipleOffers.map((o) => {
            return (
              <div
                key={o.title}
                className='flex flex-col'
              >
                <OfferCard
                  data={o}
                  onOpen={(offer) => {
                    setSelectedOffer(offer);
                    setIsDrawerOpen(true);
                  }}
                />
              </div>
            );
          })}
        </div>
      ) : (
        <div className='w-full grid grid-cols-1 md:grid-cols-2 gap-8 @max-md:grid-cols-1'>
          {leftOffer && (
            <div className='flex flex-col'>
              <OfferCard
                data={leftOffer}
                onOpen={(offer) => {
                  setSelectedOffer(offer);
                  setIsDrawerOpen(true);
                }}
              />
            </div>
          )}

          {rightOffer && (
            <div className='flex flex-col'>
              <OfferCard
                data={rightOffer}
                onOpen={(offer) => {
                  setSelectedOffer(offer);
                  setIsDrawerOpen(true);
                }}
              />
            </div>
          )}
        </div>
      )}

      {/* {link?.url && link?.label && (
        <Link
          href={link.url}
          target={link.targetAttribute || '_self'}
          rel={link.relAttribute || undefined}
          className='heading-6 flex justify-center items-center grow px-8 py-4 font-semibold border-2 max-md:border-brand-offers-mobile-cta-border border-secondary-500 max-md:bg-brand-offers-mobile-cta-bg bg-transparent max-md:text-brand-offers-mobile-cta-text rounded-lg transition-all duration-200 hover:bg-secondary-500 hover:text-white focus:outline-none focus:ring-2 focus:ring-secondary-500/30 focus:ring-offset-2 max-sm:w-full'
        >
          {link.label}
        </Link>
      )} */}
      {link?.url && link?.label && (
        <SecondaryCtaLink
          buttonText={link.label}
          linkUrl={link.url}
          target={link.targetAttribute}
          relAttribute={link.relAttribute}
          className='max-sm:w-full max-md:border-brand-offers-mobile-cta-border max-md:bg-brand-offers-mobile-cta-bg max-md:text-brand-offers-mobile-cta-text'
        />
      )}

      <OfferDetails
        data={selectedOffer}
        isOpen={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
      />
    </section>
  );
};

export default Offers_Component;
